import { CSSProperties } from "react";

export const getBorderColor: (style?: CSSProperties) => string | undefined = (
  style,
) =>
  style?.borderColor ??
  style?.borderTopColor ??
  style?.borderLeftColor ??
  style?.borderBottomColor ??
  style?.borderRightColor;

export const getBordersColor = (
  style: CSSProperties | undefined,
  defaultColor: string,
) => ({
  borderTopColor: style?.borderTopColor ?? defaultColor,
  borderLeftColor: style?.borderLeftColor ?? defaultColor,
  borderBottomColor: style?.borderBottomColor ?? defaultColor,
  borderRightColor: style?.borderRightColor ?? defaultColor,
});

export const getBorderWidth: (
  style?: CSSProperties,
) => string | number | undefined = (style) =>
  style?.borderWidth ??
  style?.borderTopWidth ??
  style?.borderLeftWidth ??
  style?.borderBottomWidth ??
  style?.borderRightWidth;

export const getBorderRadius: (
  style?: CSSProperties,
  defaultRadius?: number,
) => string | number | undefined = (style, defaultRadius) =>
  style?.borderRadius ??
  style?.borderTopLeftRadius ??
  style?.borderTopRightRadius ??
  style?.borderBottomLeftRadius ??
  style?.borderBottomRightRadius ??
  style?.borderStartStartRadius ??
  style?.borderStartEndRadius ??
  style?.borderEndStartRadius ??
  style?.borderEndEndRadius ??
  defaultRadius;

type FontStyles = {
  fontSize?: number | string;
  lineHeight?: number | string;
  letterSpacing?: number | string;
};
export const getFontSizing: (
  style?: CSSProperties,
  defaultStyles?: FontStyles,
) => FontStyles = (style, defaultStyles = {}) => {
  const ret: FontStyles = { ...defaultStyles };
  if (style?.fontSize) ret.fontSize = style.fontSize;
  if (style?.lineHeight) ret.lineHeight = style.lineHeight;
  if (style?.letterSpacing) ret.letterSpacing = style.letterSpacing;
  return ret;
};
